import variables from '../../styles/variables.module.scss';
import caseimg from '../../assets/cases/wrkat-caseimg.jpg';

export default {
  path: '/cases/wrkat',
  color: variables.wrkatSecondary,
  case: { fall: caseimg },
  title: 'Wrkat',
  description: 'Co-working, whenever, wherever',
  headline: 'iOS & Android application',
  isWeb: false,
  isAndroid: false,
};
